var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGearKnob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 71.6 107.4",
    style: {
      enableBackground: "new 0 0 71.6 107.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0,
    width: 71.6,
    height: 107.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.6,97l0-3.9c0-2.1-1.8-3.9-3.9-3.9h-4.9l0-9.7c0-2.1-1.8-3.8-4-3.8H43.2L52,33.1l4.9-1.9 c2.1-0.8,3.7-2.6,4.2-4.8l3-13.4c0.3-1.5-0.3-3-1.5-4c-3.8-3-9.1-7.1-10.8-8.4c-0.8-0.6-1.7-0.8-2.7-0.6l-12,3.1 c-2.4,0.6-4.1,2.7-4.2,5.2l-3.7,67.4H13.8c-2.2,0-3.9,1.7-3.9,3.8l0,9.7H3.9C1.8,89.3,0,91,0,93.1L0,97h0l0,1.5l0,1.2l0,3.9 c0,2.1,1.8,3.9,3.9,3.9h63.8c2.2,0,3.9-1.7,3.9-3.9l0-3.9h0l0-1.3L71.6,97z M11.4,79.5c0-1.3,1.1-2.3,2.4-2.3h16.9l3.8-68.8 c0.1-1.8,1.3-3.3,3.1-3.8l12-3.1c0.5-0.1,1,0,1.4,0.3c1.6,1.2,6.9,5.4,10.8,8.4c0.8,0.6,1.1,1.5,0.9,2.5l-3,13.4 c-0.4,1.7-1.6,3.1-3.2,3.8l-11.9,4.7v1.6l5.9-2.3l-9,43.5h17.4c1.4,0,2.5,1,2.5,2.3l0,9.7H59l-47.6,0L11.4,79.5z M70.1,103.5 c0,1.3-1.1,2.4-2.4,2.4H3.9c-1.3,0-2.4-1.1-2.4-2.4l0-5l0-5.3c0-1.3,1.1-2.4,2.4-2.4l63.8,0c1.3,0,2.4,1.1,2.4,2.4l0,5.2 L70.1,103.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGearKnob);
export default __webpack_public_path__ + "static/media/Gear_knob.e5247085962980a098920cbb7c41708a.svg";
export { ForwardRef as ReactComponent };